import { Masks } from './types';

const isNeedMaskedEntry = (value: string, masksItems: Array<string>) =>
  value.match(new RegExp(masksItems.join('|'), `i`));
const isNeedMaskedMatch = (value: string, masksItems: Array<string>) =>
  masksItems.some((item: string) => item.toLowerCase() === value.toLowerCase());
const isObject = (value: any) =>
  typeof value === 'object' && value !== null && !Array.isArray(value);
const isArray = (value: any) => Array.isArray(value);

// eslint-disable-next-line default-param-last
const entryMasking = (prop = '', obj: any, masksKeys: Array<string>) => {
  if (isNeedMaskedEntry(prop, masksKeys)) {
    return '********';
  }
  if (!isObject(obj) && !isArray(obj)) {
    return obj;
  }
  const nextObj = isObject(obj) ? {} : [];
  // eslint-disable-next-line no-shadow
  for (const [prop, value] of Object.entries(obj)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    nextObj[prop] = entryMasking(prop, value, masksKeys);
  }
  return nextObj;
};
//Todo: Refactor this
// eslint-disable-next-line default-param-last
const matchMasking = (prop = '', obj: any, masksKeys: Array<string>) => {
  if (isNeedMaskedMatch(prop, masksKeys)) {
    return '********';
  }
  if (!isObject(obj) && !isArray(obj)) {
    return obj;
  }
  const nextObj = isObject(obj) ? {} : [];
  // eslint-disable-next-line no-shadow
  for (const [prop, value] of Object.entries(obj)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    nextObj[prop] = matchMasking(prop, value, masksKeys);
  }
  return nextObj;
};

/**
 * @param records
 * @param masks
 */
function maskingRecords(records: string, masks: Masks): string {
  if (masks && masks.strategic === 'entry') {
    try {
      const recordsObj = JSON.parse(records);
      return JSON.stringify(entryMasking('', recordsObj, masks.keys));
    } catch {
      return records;
    }
  }
  if (masks && masks.strategic === 'match') {
    try {
      const recordsObj = JSON.parse(records);
      return JSON.stringify(matchMasking('', recordsObj, masks.keys));
    } catch {
      return records;
    }
  }
  return records;
}

export { maskingRecords };
